import config from 'config.json';

const {searchParams} = new URL(document.location);

export const prependDigitalAssetsUrl = (path, imageSizeSuffix = '') =>
    !(searchParams.get('useMocks') === 'y') && path !== '' && path !== '/'
        ? new URL(`${path}${imageSizeSuffix}`, config.cloudFront).href
        : path;
